import { apiCall } from "../../lib/supabase";

export const getBrandByName = async (brand) => {
  const response = await apiCall.from("brand").select("*").eq("name", brand);

  return response;
};
